export default [
  
    {
        path: "/solicitudes-bolson",
        name: "solicitudes-bolson",
        component: () =>
            import(/* webpackChunkName: "bolsonPagos" */ "./views/bolsonPagos.vue"),
    },
    {
        path: "/presupuestos-movimientos/renuncia/:id",
        name: "indemnizacion-renuncias",
        component: () =>
            import(/* webpackChunkName: "bolsonPagos" */ "./views/IndemnizacionRenuncia.vue"),
    },
    {
        path: "/presupuestos-movimientos/despido/:id", 
        name: "solicitudes-indemnizacion-despidos",
        component: () =>
            import(/* webpackChunkName: "bolsonPagos" */ "./views/tablaindemnizaciondespidos.vue"),
    },
    {
        path: "/presupuestos-movimientos/consultoria/:id",
        name: "solicitudes-remuneracion-consultorias",
        component: () =>
            import(/* webpackChunkName: "bolsonPagos" */ "./views/tablaremuneracionesporconsultorias.vue"),
    },
    

]